








import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Paypal extends Vue {
  paypalMe () {
    window.open('https://paypal.me/kiswacom/5USD')
  }
}
